module.exports = "https://static.wmbcdn.com/uniweb/images/816b023c1a8e30f2fa25d299e20f61ae.svg";